import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { WorkoutPage } from "@/features/workout";

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: WorkoutPage,
});
